import { AWSRegions } from "../generated/ups/graphql";

export const Regions = [
  { value: "US_EAST_1", label: "us-east-1" },
  { value: "US_EAST_2", label: "us-east-2" },
  { value: "US_WEST_1", label: "us-west-1" },
  { value: "US_WEST_2", label: "us-west-2" },
  { value: "EU_CENTRAL_1", label: "eu-central-1" },
  { value: "EU_WEST_1", label: "eu-west-1" },
  { value: "EU_WEST_2", label: "eu-west-2" },
  { value: "EU_WEST_3", label: "eu-west-3" },
  { value: "EU_NORTH_1", label: "eu-north-1" },
] as const;

export type RegionsType = AWSRegions;

export const DEFAULT_REGION = "US_EAST_1" as RegionsType;
